import { Link } from "@tanstack/react-router";
import {
	mergeAttributes,
	Node,
	type NodeViewProps,
	NodeViewWrapper,
	ReactNodeViewRenderer,
} from "@tiptap/react";
import { Button } from "@/components/ui/button";

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		button: {
			/**
			 * Set media
			 */
			setButton: (options: {
				background: string;
				color: string;
				text: string;
				href: string;
			}) => ReturnType;
		};
	}
}

function ButtonNode({ node }: NodeViewProps) {
	return (
		<NodeViewWrapper className="react-component">
			<div className="flex w-full justify-center">
				<Link to={node.attrs.href} target="_blank">
					<Button
						type="button"
						style={{
							color: node.attrs.color,
							backgroundColor: node.attrs.background,
						}}
					>
						{node.attrs.text}
					</Button>
				</Link>
			</div>
		</NodeViewWrapper>
	);
}

export const ButtonExtension = Node.create({
	name: "button",

	group: "block",

	atom: true,

	addAttributes() {
		return {
			href: {
				default: null,
			},
			background: {
				default: "#036141",
			},
			color: {
				default: "#ffffff",
			},
			text: {
				default: "Clique Aqui",
			},
		};
	},

	parseHTML() {
		return [
			{
				tag: "button",
			},
		];
	},

	renderHTML({ HTMLAttributes }) {
		return ["button", mergeAttributes(HTMLAttributes)];
	},

	addCommands() {
		return {
			setButton:
				(options) =>
				({ commands }) => {
					return commands.insertContent([
						{
							type: this.name,
							attrs: options,
						},
						{
							type: "hardBreak",
						},
					]);
				},
		};
	},

	addNodeView() {
		return ReactNodeViewRenderer(ButtonNode);
	},
});
